import { render, staticRenderFns } from "./SmsBuilder.vue?vue&type=template&id=995abb7c&scoped=true"
import script from "./SmsBuilder.vue?vue&type=script&lang=js"
export * from "./SmsBuilder.vue?vue&type=script&lang=js"
import style0 from "./SmsBuilder.vue?vue&type=style&index=0&id=995abb7c&prod&lang=scss"
import style1 from "./SmsBuilder.vue?vue&type=style&index=1&id=995abb7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995abb7c",
  null
  
)

export default component.exports